import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { lang } from './lang.module';

let initialState = {
    alert: { ...alert.state },
};

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        refCount: 0,
        isLoading: false,
        secretKey: "",
        url: "",
    },
    modules: {
        alert,
        lang,
    },
    mutations: {
        reset (state) {
            Object.keys(state).forEach(key => {
                Object.assign(state[key], initialState[key]);
            });
        },
        loading (state, isLoading) {
        // console.log({isLoading})
            if (isLoading) {
                state.refCount++;
                state.isLoading = true;
            } else if (state.refCount > 0) {
                state.refCount--;
                setTimeout(function () { state.isLoading = (state.refCount > 0); }, 300);
            }
        },
        setLoginInfo (state, { secretKey, url }) {
            state.secretKey = secretKey;
            state.url = url;
        },
        clearLoginInfo () {
            state.secretKey = null;
            state.url = null;
        }
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js